export interface IGridOperator {
  id?: number;
  name?: string | null;
  ean?: string | null;
  fileNumber?: string | null;
}

export const defaultValue: Readonly<IGridOperator> = {};
